import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { BTN_PRIMARY, INPUT } from "@/lib/styles";
import { toast } from "sonner";

export default function PairDevice() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const { applySession } = useAuth();
  const [code, setCode] = useState(params.get("code") || "");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const consume = async (value) => {
    setError("");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/pair/consume", { code: value });
      applySession({ user: data.user, token: data.token });
      toast.success("¡Dispositivo vinculado!");
      navigate("/");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const c = params.get("code");
    if (c) consume(c);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen bg-white dark:bg-slate-950 text-slate-900 dark:text-slate-100 flex items-center justify-center p-6 font-body">
      <div className="w-full max-w-sm">
        <div className="flex items-center gap-2.5 mb-8 justify-center">
          <img src="/icon-192.png" alt="Notacora" className="w-10 h-10 rounded-lg" />
          <span className="font-heading font-semibold text-2xl tracking-tight">Notacora</span>
        </div>
        <h1 className="font-heading font-light text-2xl tracking-tight mb-1 text-center">Vincular dispositivo</h1>
        <p className="font-body text-sm text-slate-500 dark:text-slate-400 mb-6 text-center">
          Introduce el código que ves en tu dispositivo principal (o escanea su QR).
        </p>
        <input className={INPUT} placeholder="Pega el código aquí" value={code} onChange={(e) => setCode(e.target.value)} data-testid="pair-code-input" />
        {error && (
          <p className="font-body text-xs text-rose-500 bg-rose-500/10 border border-rose-500/20 rounded-lg px-3 py-2 mt-3" data-testid="pair-error">
            {error}
          </p>
        )}
        <button onClick={() => consume(code)} className={`${BTN_PRIMARY} w-full py-3 mt-4`} disabled={loading || !code} data-testid="pair-consume">
          {loading ? "Vinculando..." : "Vincular este dispositivo"}
        </button>
      </div>
    </div>
  );
}
